import cx from 'classix';
import { ReactNode } from 'react';
import { Icon, IconKey } from '../atoms';

type TagSizes = 'sm' | 'md' | 'lg';

type TagProps = {
  size: TagSizes;
  children: ReactNode;
  leadIcon?: IconKey;
  tailIcon?: IconKey;
  onTailIconClick?: () => void;
};
export const Tag = (props: TagProps) => {
  const { children, leadIcon, tailIcon, size = 'md', onTailIconClick } = props;

  return (
    <div
      className={cx(
        'font-sans text-sm tracking-wider rounded-md focus:outline-none inline-flex gap-[3px] justify-center items-center border border-gray-200',
        size === 'sm' && 'py-[3px]',
        size === 'sm' && !tailIcon && !leadIcon && 'px-2',
        size === 'sm' && tailIcon && !leadIcon && 'pr-1 pl-2',
        size === 'sm' && !tailIcon && leadIcon && 'pr-2 pl-1',
        size === 'sm' && tailIcon && leadIcon && 'pr-0.5 pl-[5px]',

        size === 'md' && 'py-0.5',
        size === 'md' && !tailIcon && !leadIcon && 'px-[9px]',
        size === 'md' && tailIcon && !leadIcon && 'pr-1 pl-[9px]',
        size === 'md' && !tailIcon && leadIcon && 'pr-[9px] pl-1',
        size === 'md' && tailIcon && leadIcon && 'px-1',

        size === 'lg' && 'py-1',
        size === 'lg' && !tailIcon && !leadIcon && 'px-2.5',
        size === 'lg' && tailIcon && !leadIcon && 'pr-1 pl-2.5',
        size === 'lg' && !tailIcon && leadIcon && 'pr-2.5 pl-1',
        size === 'lg' && tailIcon && leadIcon && 'px-1',

        (size === 'sm' || size === 'md') && 'h-6',
        size === 'lg' && 'h-7',
      )}
    >
      {leadIcon && <Icon type={leadIcon} size='16' />}
      {children}
      {tailIcon && <Icon type={tailIcon} onClick={onTailIconClick} size='16' />}
    </div>
  );
};
